import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { LCPState, LCPDispatch } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useLCPDispatch: () => LCPDispatch = useDispatch;
export const useLCPSelector: TypedUseSelectorHook<LCPState> = useSelector;
